import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicFormModule } from 'src/app/core/dynamic-form/dynamic-form.module';

import { TestRoutingModule } from './test-routing.module';
import { TestComponent } from './test.component';
import { CustomSwitchModule } from 'src/app/core/custom-switch/custom-switch.module';
import { CustomCheckboxModule } from 'src/app/core/custom-checkbox/custom-checkbox.module';
import { CustomMultiSelectModule } from 'src/app/core/custom-multi-select/custom-multi-select.module';
import { GridTestComponent } from './grid-test/grid-test.component';
import { CustomGridModule } from 'src/app/core/custom-grid/custom-grid.module';
import { TooltipModule } from '@syncfusion/ej2-angular-popups';
import { CustomTextAreaModule } from 'src/app/core/custom-text-area/custom-text-area.module';
import { CustomDividerModule } from 'src/app/core/custom-divider/custom-divider.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TabTestComponent } from './tab-test/tab-test.component';
import { CustomTabsModule } from 'src/app/core/custom-tabs/custom-tabs.module';
import { EditHistoryModule } from 'src/app/core/edit-history/edit-history.module';
import { MultiSelectModule } from '@syncfusion/ej2-angular-dropdowns';
import { LanguageComponent } from './language/language.component';
import { LanguageSwitcherModule } from 'src/app/features/language-switcher/language-switcher.module';
import {TranslateModule} from '@ngx-translate/core';
import { CustomStepsModule } from 'src/app/core/custom-steps/custom-steps.module';
import { ContrattiGridTestComponent } from './contratti-grid/contratti-grid-test.component';
import { StyleTestComponent } from './style-test/style-test.component';
import { CustomMultiSelectLazyModule } from "../../core/custom-multi-select-lazy/custom-multi-select-lazy.module";
import { TreeGridModule } from '@syncfusion/ej2-angular-treegrid';
import { CustomTreeGridModule } from "../../core/custom-treegrid/custom-treegrid.module";
import { RatingModule, UploaderModule } from '@syncfusion/ej2-angular-inputs';
import { CustomFileUploaderModule } from 'src/app/core/custom-file-uploader/custom-file-uploader.module';
import { ButtonModule, RadioButton, RadioButtonModule } from '@syncfusion/ej2-angular-buttons';
import { CustomFileDownloaderModule } from 'src/app/core/custom-file-downloader/custom-file-downloader.module';


@NgModule({
    declarations: [
        TestComponent,
        GridTestComponent,
        TabTestComponent,
        LanguageComponent,
        StyleTestComponent,
        ContrattiGridTestComponent,
    ],
    imports: [
        CommonModule,
        TestRoutingModule,
        DynamicFormModule,
        CustomSwitchModule,
        CustomCheckboxModule,
        CustomMultiSelectModule,
        CustomGridModule,
        CustomTextAreaModule,
        TooltipModule,
        CustomDividerModule,
        FormsModule,
        ReactiveFormsModule,
        CustomTabsModule,
        EditHistoryModule,
        TreeGridModule,
        MultiSelectModule,
        LanguageSwitcherModule,
        TranslateModule,
        CustomStepsModule,
        CustomMultiSelectLazyModule,
        CustomTreeGridModule,
        CustomFileUploaderModule,
        ButtonModule,
        CustomFileDownloaderModule,
        RadioButtonModule,
        RatingModule
    ]
})
export class TestModule { }
